import gql from "graphql-tag";

export const GET_ITEMS_ADMIN = gql`
  query getItemsAdmin {
    itemsAdmin {
      availableItems {
        equiped
        icon
        id
        maxQuantity
        price
        rarity
        state
        type
        x
        y
        maxUsesPerKickoff
      }
      itemStats {
        itemId
        totalOwned
        totalPlayers
        newspaperVersions {
          version
          count
        }
      }
    }
  }
`;
